import { useState } from 'react';
import { Box } from '@mui/material';
import { MessageBox } from 'components';
import { Container, StyledTab, StyledTabs, TabPanel } from './ChangeLog.styles';
import { Section } from '../Section';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = ({ children, value, index, ...other }: TabPanelProps) => (
  <TabPanel
    role="tabpanel"
    hidden={value !== index}
    id={`changelog-tabpanel-${index}`}
    aria-labelledby={`changelog-tab-${index}`}
    {...other}
  >
    {value === index && children}
  </TabPanel>
);

const ComingSoonMessage = () => (
  <Box sx={{ py: 1 }}>
    <MessageBox 
      title="Coming soon..." 
      tagline="This feature will be available in a future update." 
      fullWidth={false}
      titleStyleOverride={{ fontSize: '0.875rem' }}
    />
  </Box>
);

const ChangeLog = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Section title="Change Log">
      <Container>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <StyledTabs 
            value={value} 
            onChange={handleChange}
            aria-label="changelog tabs"
          >
            <StyledTab label="Notes" id="changelog-tab-0" aria-controls="changelog-tabpanel-0" />
            <StyledTab label="Changelog" id="changelog-tab-1" aria-controls="changelog-tabpanel-1" />
          </StyledTabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <ComingSoonMessage />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ComingSoonMessage />
        </CustomTabPanel>
      </Container>
    </Section>
  );
};

export default ChangeLog;
